import CurrencyRubleIcon from "@mui/icons-material/CurrencyRuble";
import {
    Button,
    Checkbox,
    Chip,
    Collapse,
    FormControlLabel,
    IconButton,
    InputAdornment,
    TextField,
    Typography,
} from "@mui/material";
import React, {useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {editArray, updateMerchantPaymentMethods, getMerchants} from "../store/slices/merchantSlice";
import {DragIndicator, ExpandMore, ExpandLess} from "@mui/icons-material";
import {setSnackBar} from "../store/slices/uiSlice";

function MerchantSetting({merchant}) {
    const merchants = useSelector((state) => state.merchant.merchants);
    const allPaymentMethods = useSelector((state) => state.merchant.allPaymentMethods);
    const dispatch = useDispatch();
    const [expanded, setExpanded] = useState(false);
    const [savingPM, setSavingPM] = useState(false);

    const {register, control, handleSubmit, setValue, getValues, watch} =
        useForm({
            defaultValues: {
                id: null,
                rate: 0,
                commission: 0,
                min_limit: 0,
                max_limit: 0,
                active: false,
            },
        });

    const watchForm = watch();

    const merchantPivotData = merchant.merchantPaymentMethods || [];

    const [localPM, setLocalPM] = useState(() => {
        const map = {};
        merchantPivotData.forEach((row) => {
            map[row.payment_method_id] = {
                enabled: Number(row.is_active) === 1,
                commission: Number(row.commission || 0),
            };
        });
        return map;
    });

    React.useEffect(() => {
        const map = {};
        const rows = merchant.merchantPaymentMethods || [];
        rows.forEach((row) => {
            map[row.payment_method_id] = {
                enabled: Number(row.is_active) === 1,
                commission: Number(row.commission || 0),
            };
        });
        setLocalPM(map);
    }, [merchant.merchantPaymentMethods]);

    React.useEffect(() => {
        dispatch(editArray(watchForm));
    }, [watchForm]);

    React.useEffect(() => {
        setValue("id", merchant.id);
        setValue("rate", merchant.rate);
        setValue("commission", merchant.commission);
        setValue("min_limit", merchant.min_limit);
        setValue("max_limit", merchant.max_limit);

        if (merchant.active == 1) {
            setValue("active", true);
        } else {
            setValue("active", false);
        }
    }, []);

    function fullRate() {
        let rate = getValues("rate");

        let commissionPercent = Number(watchForm.commission) / 100;
        let rateCommission = rate + rate * commissionPercent;
        return rateCommission.toFixed(2);
    }

    const togglePaymentMethod = (pmId) => {
        setLocalPM((prev) => {
            const current = prev[pmId];
            return {
                ...prev,
                [pmId]: {
                    enabled: !current?.enabled,
                    commission: current?.commission || 0,
                },
            };
        });
    };

    const setCommissionForPM = (pmId, value) => {
        setLocalPM((prev) => ({
            ...prev,
            [pmId]: {
                ...prev[pmId],
                commission: value,
            },
        }));
    };

    const savePaymentMethods = async () => {
        setSavingPM(true);
        const paymentMethodsData = allPaymentMethods.map((pm) => ({
            payment_method_id: pm.id,
            commission: Number(localPM[pm.id]?.commission) || 0,
            is_active: !!localPM[pm.id]?.enabled,
        }));

        try {
            await dispatch(
                updateMerchantPaymentMethods({
                    merchant_id: merchant.id,
                    payment_methods: paymentMethodsData,
                })
            );
            await dispatch(getMerchants());
            dispatch(
                setSnackBar({
                    open: true,
                    text: `Способы оплаты для ${merchant.type} сохранены`,
                })
            );
        } catch (e) {
            dispatch(
                setSnackBar({
                    open: true,
                    text: "Ошибка сохранения способов оплаты",
                })
            );
        }
        setSavingPM(false);
    };

    const enabledCount = Object.values(localPM).filter((v) => v.enabled).length;

    return (
        <div>
            <Typography variant="subtitle1" className="mb-3">
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <b>{merchant.priority}. {merchant.type}</b>
                        <div className={"mx-3"}>
                            <FormControlLabel
                                control={
                                    <Controller
                                        name="active"
                                        control={control}
                                        render={({field}) => (
                                            <Checkbox {...field} checked={field.value}/>
                                        )}
                                    />
                                }
                                label="Включить систему"
                            />
                        </div>
                    </div>
                </div>
            </Typography>
            <div className="w-100 d-flex align-items-center">
                <div>
                    <DragIndicator color={"disabled"} fontSize={'large'}/>
                </div>
                <div className={'w-100'}>
                    <div className="row">
                        <div className="col-6  d-flex w-100 ">
                            <div className={"w-100"} style={{paddingRight: "5px"}}>
                                <Controller
                                    name="commission"
                                    control={control}
                                    render={({field}) => (
                                        <TextField
                                            size="small"
                                            sx={{width: "100%"}}
                                            {...field}
                                            type="number"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        {merchant.type == 'card_kzt' ? <div style={{fontSize: '22px'}}>₸</div> :
                                                            <CurrencyRubleIcon/>}
                                                    </InputAdornment>
                                                ),
                                            }}
                                            label={`Комиссия. Итоговый курс - ${fullRate()} ${merchant.type == 'card_kzt' ? '₸' : '₽'}`}
                                        />
                                    )}
                                />
                            </div>
                            <div className={"w-100"} style={{paddingLeft: "5px"}}>

                                <Controller
                                    name="rate"
                                    control={control}
                                    render={({field}) => (
                                        <TextField
                                            size="small"
                                            sx={{width: "100%"}}
                                            {...field}
                                            type="number"
                                            disabled={true}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        {merchant.type == 'card_kzt' ? <div style={{fontSize: '22px'}}>₸</div> :
                                                            <CurrencyRubleIcon/>}
                                                    </InputAdornment>
                                                ),
                                            }}
                                            label="Курс обмена. 1 USDT = "
                                        />
                                    )}
                                />

                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6 mt-3 d-flex w-100 ">
                            <div className={"w-100"} style={{paddingRight: "5px"}}>
                                <Controller
                                    name="min_limit"
                                    control={control}
                                    render={({field}) => (
                                        <TextField
                                            size="small"
                                            sx={{width: "100%"}}
                                            {...field}
                                            type="number"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        {merchant.type == 'card_kzt' ? <div style={{fontSize: '22px'}}>₸</div> :
                                                            <CurrencyRubleIcon/>}
                                                    </InputAdornment>
                                                ),
                                            }}
                                            label={`Минимальный лимит`}
                                        />
                                    )}
                                />
                            </div>
                            <div className={"w-100"} style={{paddingLeft: "5px"}}>
                                <Controller
                                    name="max_limit"
                                    control={control}
                                    render={({field}) => (
                                        <TextField
                                            size="small"
                                            sx={{width: "100%"}}
                                            {...field}
                                            type="number"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        {merchant.type == 'card_kzt' ? <div style={{fontSize: '22px'}}>₸</div> :
                                                            <CurrencyRubleIcon/>}
                                                    </InputAdornment>
                                                ),
                                            }}
                                            label={`Максимальный лимит`}
                                        />
                                    )}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="mt-2">
                        <div
                            className="d-flex align-items-center"
                            style={{cursor: "pointer"}}
                            onClick={() => setExpanded(!expanded)}
                        >
                            <Typography variant="body2" color="text.secondary">
                                Способы оплаты ({enabledCount} из {allPaymentMethods.length})
                            </Typography>
                            <IconButton size="small">
                                {expanded ? <ExpandLess fontSize="small"/> : <ExpandMore fontSize="small"/>}
                            </IconButton>
                        </div>
                        <Collapse in={expanded}>
                            <div
                                style={{
                                    border: "1px solid #e0e0e0",
                                    borderRadius: 8,
                                    padding: 16,
                                    marginTop: 4,
                                    background: "#fafafa",
                                }}
                            >
                                {allPaymentMethods.map((pm, index) => {
                                    const isEnabled = !!localPM[pm.id]?.enabled;
                                    const pmCommission = localPM[pm.id]?.commission ?? 0;
                                    const totalCommission = Number(watchForm.commission) + Number(pmCommission);

                                    return (
                                        <div
                                            key={pm.id}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "6px 0",
                                                borderBottom: index < allPaymentMethods.length - 1 ? "1px solid #eeeeee" : "none",
                                            }}
                                        >
                                            <Checkbox
                                                checked={isEnabled}
                                                onChange={() => togglePaymentMethod(pm.id)}
                                                size="small"
                                                sx={{p: "4px", mr: 1}}
                                            />
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    width: 180,
                                                    flexShrink: 0,
                                                    color: isEnabled ? "text.primary" : "text.disabled",
                                                }}
                                            >
                                                {pm.label || pm.value}
                                            </Typography>
                                            {isEnabled ? (
                                                <div style={{display: "flex", alignItems: "center", gap: 10, marginLeft: "auto"}}>
                                                    <TextField
                                                        size="small"
                                                        type="number"
                                                        value={pmCommission}
                                                        onChange={(e) =>
                                                            setCommissionForPM(pm.id, e.target.value)
                                                        }
                                                        sx={{width: 140}}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">%</InputAdornment>
                                                            ),
                                                        }}
                                                        label="Доп. комиссия"
                                                    />
                                                    <Chip
                                                        size="small"
                                                        label={`Итого: ${totalCommission}%`}
                                                        color={Number(pmCommission) !== 0 ? "primary" : "default"}
                                                        variant={Number(pmCommission) !== 0 ? "filled" : "outlined"}
                                                        sx={{minWidth: 90}}
                                                    />
                                                </div>
                                            ) : (
                                                <Typography
                                                    variant="caption"
                                                    sx={{marginLeft: "auto", color: "text.disabled"}}
                                                >
                                                    Выключен
                                                </Typography>
                                            )}
                                        </div>
                                    );
                                })}

                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={savePaymentMethods}
                                    disabled={savingPM}
                                    sx={{mt: 2}}
                                >
                                    {savingPM ? "Сохранение..." : "Сохранить способы оплаты"}
                                </Button>
                            </div>
                        </Collapse>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default MerchantSetting;
